import { Config } from './config';
import { Util } from './util';
import { NewEditForm } from './new_edit_form';

class New {

    constructor() {
        this.CONFIG = new Config();
        this.NEW_EDIT_FORM = new NewEditForm();
    }


    handleSearchBefore(e) {
        if(!e.detail.isSearchingMore) {
            this.COMPLAINTS_TABLE.Clear();
        }
        this.COMPLAINTS_TABLE.HiddenNoComplaintsP();
        this.COMPLAINTS_TABLE.LoadingStart();
    }


    handleSearchComplete() {
        this.COMPLAINTS_TABLE.LoadingStop();
    }


    handleSearched(e) {
        if(e.detail != null && e.detail.isNotFound) {
            this.COMPLAINTS_TABLE.VisibleNoComplaints();
        } else {
            this.COMPLAINTS_TABLE.HiddenNoComplaintsP();
        }
        this.COMPLAINTS_TABLE.Append(e.detail.objects);
    }


    handleScrollBottomDetected() {
        this.SEARCH_FORM.GetMoreComplaints();
    }


    setUpSearchFormEventListener() {
        this.SEARCH_FORM.GetRootElm().addEventListener('searchbefore', (e) => { this.handleSearchBefore(e); }, false);
        this.SEARCH_FORM.GetRootElm().addEventListener('searched', (e) => { this.handleSearched(e); }, false);
        this.SEARCH_FORM.GetRootElm().addEventListener('searchcomplete', () => { this.handleSearchComplete(); }, false);
    }


    setUpComplaintsTableEventListener() {
        this.COMPLAINTS_TABLE.GetRootElm().addEventListener('scrollbottomdetected', () => { this.handleScrollBottomDetected(); }, false);
    }


    Run() {
        this.NEW_EDIT_FORM.Run();
    }

}
export { New }
